import { all, call, put, select } from 'redux-saga/effects'

import ApiSagas from '../api/sagas'
import { actions, selectors } from '..'
import {
  plans,
  reducedCurrentPlan,
  currentPlan,
  fullPlans,
} from '../../graphql/Services/User/queries'

export default class PlanSagas {
  static *init() {
    yield
    return
  }

  static *loadReducedCurrentPlan() {
    const results = yield call(ApiSagas.query, reducedCurrentPlan())
    if (results?.data) {
      yield put(actions.user.setCurrentPlan(results?.data))
    } else {
      yield put(actions.user.setCurrentPlan(null))
    }
  }

  static *loadCurrentPlan() {
    const results = yield call(ApiSagas.query, currentPlan())
    if (results?.data) {
      yield put(actions.user.setCurrentPlan(results?.data))
    } else {
      yield put(actions.user.setCurrentPlan(null))
    }
  }

  static *loadPlans(page = 1) {
    const currentPlans = yield select(selectors.user.plans)
    const results = yield call(
      ApiSagas.query,
      plans({
        first: 5,
        page,
      })
    )
    yield put(
      actions.user.setPlans(
        currentPlans
          ? [...currentPlans, ...results?.data?.plans?.data]
          : results?.data?.plans?.data
      )
    )
    yield put(
      actions.planninghistory.setHasMorePages(
        results?.data?.plans?.paginatorInfo?.hasMorePages
      )
    )
  }

  static *loadFullPlans(page = 1) {
    const results = yield call(
      ApiSagas.query,
      fullPlans({
        first: 50,
        page,
      })
    )
    yield put(actions.user.setPlans(results?.data?.plans?.data))
  }

  static *loop() {
    yield all([
      //
    ])
  }
}
